import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import CommonForm from "../Common/CommonForm";
import UltimateAdminList from "./UltimateComponents/UltimateAdminList";


class UltimateAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            model: null,
            models: null,
        }
    }

    async componentDidMount() {
        await this.retrieveData();
    }

    async retrieveData() {
        const api = new BaseApi();
        const url = 'admin/models/'
        let response = await api.get(
            url,
            {},
        );
        if (response.status === 200){
            this.setState({
                models: response.data,
            });
        }
    }

    async applyModel(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        this.setState({
            model: formDataObj.model,
        })
    }

    render() {
        if (!this.state.models) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Stack>
                <CommonForm
                    processForm={this.applyModel.bind(this)}
                    fields={[
                        {
                            'name': 'model',
                            'label': 'Модель',
                            'xs': 12,
                            'sm': null,
                            'md': 6,
                            'lg': null,
                            'xl': null,
                            'required': false,
                            'default': null,
                            'type': 'select',
                            'options': this.state.models,
                        },
                        {
                            'type': 'submit',
                            'label': 'Применить'
                        }
                    ]}
                />
                <UltimateAdminList
                    model={this.state.model}
                />
            </Stack>
        )
    }
}

export default UltimateAdmin
